module.exports = __webpack_public_path__ + "static/nubank-e746c54b20a0657ba31c8f1d1e52bd8b.png";